<template>
  <footer class="footer" :class="{ 'dark-mode': isDarkMode }">
    <div class="footer-content">
      <div class="brand">
        <div class="rights-reserved">
          <p>© {{ currentYear }} <span class="nima">NIMA</span><span class="degani">DEGANI™</span>. Barcha huquqlar himoyalangan.</p>
        </div>
      </div>
      <div class="social-icons">
        <a href="https://t.me/nimadegani_uz" target="_blank" rel="noopener" class="icon-link telegram" aria-label="Telegram">
          <i class="bi bi-telegram"></i>
        </a>
        <a href="https://www.instagram.com/nimadegani.uz" target="_blank" rel="noopener" class="icon-link instagram" aria-label="Instagram">
          <i class="bi bi-instagram"></i>
        </a>
        <a href="https://www.linkedin.com/company/nima-degani-uz/" target="_blank" rel="noopener" class="icon-link linkedin" aria-label="LinkedIn">
          <i class="bi bi-linkedin"></i>
        </a>
      </div>
    </div>
  </footer>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'AppFooter',
  computed: {
    ...mapGetters(['isDarkMode']),
    currentYear() {
      return new Date().getFullYear();
    },
  },
};
</script>

<style scoped>
.footer {
  color: var(--md-sys-color-on-surface-variant);
  background: var(--md-sys-color-surface-container-low);
  border-top: 1px solid var(--md-sys-color-outline-variant);
}

.footer-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: min(100% - 32px, 1280px);
  min-height: 88px;
  margin: 0 auto;
  padding: 20px 0;
  flex-wrap: wrap;
}

.brand {
  min-width: min(100%, 280px);
}

.nima {
  color: var(--md-sys-color-primary);
  font-weight: 700;
}

.degani {
  color: var(--md-sys-color-tertiary);
  font-weight: 700;
}

.rights-reserved {
  color: var(--md-sys-color-on-surface-variant);
  font: var(--md-sys-typescale-body-medium);
}

.rights-reserved p {
  margin: 0;
}

.social-icons {
  display: flex;
  align-items: center;
  gap: 8px;
}

.icon-link {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  overflow: hidden;
  border-radius: var(--md-sys-shape-corner-full);
  color: var(--md-sys-color-on-surface-variant);
  text-decoration: none;
  transition: color var(--md-sys-motion-standard);
}

.icon-link::before {
  position: absolute;
  inset: 0;
  border-radius: inherit;
  background: currentColor;
  content: "";
  opacity: 0;
  transition: opacity var(--md-sys-motion-standard);
}

.icon-link:hover::before {
  opacity: var(--md-sys-state-hover-opacity);
}

.icon-link:active::before {
  opacity: var(--md-sys-state-pressed-opacity);
}

.icon-link i {
  position: relative;
  font-size: 1.25rem;
}

.icon-link.telegram:hover {
  color: var(--md-sys-color-primary);
}

.icon-link.instagram:hover {
  color: var(--md-sys-color-tertiary);
}

.icon-link.linkedin:hover {
  color: var(--md-sys-color-primary);
}

@media (max-width: 640px) {
  .footer-content {
    justify-content: center;
    padding-bottom: calc(20px + var(--app-bottom-nav-height));
    text-align: center;
  }
}
</style>
